import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IFetchEvaluationImagesConfigurationParams } from '../../../types';

interface IEvaluationImageConfigQuery {
  queryParams: IFetchEvaluationImagesConfigurationParams;
}

/**
 * This is to track the Evaluation Image Configuration from the backend.
 */
export const EVALUATION_IMAGE_CONFIG_KEY = 'evaluation-image-config-query';

/**
 * This hook fetches the evaluation image configuration based on the provided
 * query parameters.
 */
export const useEvaluationImageConfigQuery = ({
  queryParams,
}: IEvaluationImageConfigQuery) => {
  const { categoryType } = queryParams;

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [EVALUATION_IMAGE_CONFIG_KEY, categoryType],
    networkMode: 'always',
    queryFn: () => INBOUND_API.fetchEvaluationImageConfiguration(queryParams),
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetch,
  };
};
